<template>
  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body">
      <!-- <h5>{{ reception.note_ref }}</h5> -->
      <p>
        Date de création :
        <b v-if="reception.created_at"> {{ getDate(reception.created_at) }}</b>
        |
        <b> {{ reception.note_type }} </b>
      </p>
    </div>
  </div>

  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-3">
      <h5>Liste des Colis Ajoutés</h5>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <div class="row">
          <div class="col-12">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control d-inline-block"
                    placeholder="Chercher"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        responsive
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>
          <span v-else-if="props.column.field === 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- Ticket -->
                <!-- <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="TicketsPDF( props.row.id )"
                      >
                        <i
                          class="flaticon-printing lh-1 me-8 position-relative top-1"
                        ></i>
                        Ticket
                      </button>
                    </li> -->

                <!-- Historique -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetailSuivi(props.row)"
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </button>
                </li>

                <!-- Infos -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetails(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Infos
                  </button>
                </li>
                <!-- Update -->
                <li
                  v-if="
                    auth.can('PARCELS') &&
                    (user?.role_id === 1 || user?.role_id === 2) &&
                    props.row.status !== 'NEW_PARCEL' &&
                    props.row.status !== 'WAITING_PICKUP' &&
                    props.row.status !== 'RETURNED' &&
                    props.row.status !== 'RETURNED_PARTIAL'
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showUpdate(props.row)"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </a>
                </li>
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>

  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-3">
      <h5>Scan code suivi</h5>
    </div>
    <div class="card-body">
      <form @submit.prevent="SearchColis">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-9">
              <div class="form-group">
                <label>Code Suivi :</label>
                <input
                  type="text"
                  class="form-control d-inline-block"
                  placeholder="Code Suivi"
                  v-model="codeColis"
                />
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-end">
              <button
                type="submit"
                class="btn btn-success buttons"
                style="margin-right: 12px"
              >
                <i class="ph ph-scan"></i>
              </button>
            </div>
            <div class="col-12">
              <hr />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mb-3 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header pb-3">
      <h5>Liste des Colis Ramassés</h5>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <div class="row">
          <div class="col-12">
            <div class="custom-search d-flex justify-content-end">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center">
                  <input
                    type="text"
                    class="form-control d-inline-block"
                    placeholder="Chercher"
                    v-model="searchTerm1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm1,
        }"
        responsive
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <div
              v-if="
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                globalStore.globalHelper(props.row.status_second).name
              "
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{
                '--dynamic-bg': globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              }"
            >
              {{ globalStore.globalHelper(props.row.status_second).name }}
            </div>
            <div
              v-else
              class="rounded-pill fs-13 badge text-bg-black custom-badge"
              :style="{ '--dynamic-bg': props.row.code_color }"
            >
              {{ props.row.s_name }}
            </div>
          </template>
          <template v-else-if="props.column.field === 'updated_at'">
            <span class="text-nowrap">
              {{ getDate(props.row.updated_at) }}
            </span>
          </template>
          <span v-else-if="props.column.field === 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- Historique -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetailSuivi(props.row.id)"
                  >
                    <i
                      class="flaticon-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    Historique
                  </button>
                </li>
                <!-- Infos -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showDetails(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Infos
                  </button>
                </li>
                <!-- Modifier -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center"
                    @click="showUpdate(props.row)"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </button>
                </li>
                <!-- Supprimer -->
                <li>
                  <button
                    class="dropdown-item d-flex align-items-center text-danger"
                    title="Supprimer Colis"
                  >
                    <i
                      class="flaticon-trash lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </button>
                </li>
              </ul>
            </div>
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>

  <div
    class="modal fade"
    id="modal_detail_suivi"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Historique Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <HistoryColis
            v-if="colisId"
            :colisId="colisId"
            :isOpen="isOpenModal"
            :status="statuts"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Status details colios -->
  <div
    class="modal fade"
    id="modal_detail_colis"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Détails Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <DetailsColis
            v-if="coliDetails"
            :coliDetails="coliDetails"
            :isOpen="isOpenModal"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Parcel Modal using Bootstrap -->
  <div class="modal fade" id="modal_update" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier Colis</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateParcel
            v-if="rowUpdate"
            :rowColis="rowUpdate"
            :getRecords="getRecords"
            :isOpenEdit="isOpenEdit"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Update Fees Modal using Bootstrap -->
  <!-- <div class="modal fade" id="modal_fees_edit" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h5 class="modal-title">Modifier les frais</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Fermer"
          ></button>
        </div>
        <div class="modal-body">
          <UpdateFeesParcel
            v-if="rowUpdateFees"
            :rowColis="rowUpdateFees"
            :getRecords="getRecords"
            :isOpenFees="isOpenFees"
            :hideModal="hideModal"
          />
        </div>
      </div>
    </div>
  </div> -->
</template>

<script lang="ts">
import { nextTick, onMounted, reactive, ref, watch } from "vue";
import { defineComponent } from "vue";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";
import moment from "moment";
import { Modal } from "bootstrap";
import HistoryColis from "@/components/Colis/HistoryColis.vue";
import UpdateParcel from "@/components/Colis/UpdateParcel.vue";
import DetailsColis from "@/components/Colis/DetailsColis.vue";
// import UpdateFeesParcel from "@/components/Colis/UpdateFeesParcel.vue";

export default defineComponent({
  name: "SaveSingleParcel",
  components: {
    HistoryColis,
    UpdateParcel,
    DetailsColis,
    // UpdateFeesParcel,
  },
  props: {
    noteRow: {
      type: Object,
      required: true,
    },
    getRecords: {
      type: Function,
    },
    isOpen: {
      type: Boolean,
    },
  },
  setup(props) {
    // Import Vue's reactivity helpers if needed
    // import { ref, reactive } from 'vue'
    // import Form from 'path-to-your-form-class'
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const globalStore = useGlobalStore();

    const note_BR = ref(props.noteRow);

    const isLoader = ref(true);
    const columns = ref([
      { label: "Code Suivi", field: "code" },
      { label: "Client", field: "receiver" },
      { label: "Date de ramassage", field: "updated_at" },
      { label: "Prix", field: "price" },
      { label: "Ville", field: "city_name" },
      { label: "Actions", field: "actions" },
    ]);
    const fields = ref([
      { key: "parcel_code", label: "Code d'envoi" },
      { key: "situation", label: "Etat" },
      { key: "s_name", label: "Status" },
      { key: "created_at", label: "Date", tdClass: "browserclass" },
      { key: "city_name", label: "Informations" },
      { key: "name", label: "Action par" },
    ]);
    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);
    const codeColis = ref("");
    const refreception = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const reception = ref<any>({});
    const ColiDetails = ref<any>({});
    const DetailsColis = ref([]);
    const city = ref({ id: 0, name: null });
    const CitiesList = ref([]);
    // Make sure Form is imported or defined
    const form = reactive({
      id: 0,
      code: "",
      price: "",
      phone: "",
      delivered_fees: "",
      returned_fees: "",
      refused_fees: "",
      receiver: "",
      address: "",
      note: "",
    });
    const searchTerm = ref("");
    const searchTerm1 = ref("");

    // Format date using moment.js
    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    // Search for a parcel by code
    async function SearchColis() {
      const data = new FormData();
      data.append("ref_note", reception.value.note_ref);
      data.append("code_colis", codeColis.value);
      data.append(
        "UserID",
        JSON.parse(localStorage.getItem("userData") || "{}").id
      );

      try {
        const res = await api.post("/api/auth/AddColiPickedUp", data);
        isLoader.value = false;
        codeColis.value = "";
        if (res.data.message === "success") {
          const audio = new Audio("/src/assets/success.mp3");
          audio.play();
          getData();
          props.getRecords();
        } else if (res.data.message === "not exist") {
          const audio = new Audio("/src/assets/erro.mp3");
          audio.play();
          showToast("Vous ne pouvez pas l'ajouter", "error");
        } else if (res.data.message === "error edit") {
          const audio = new Audio("/src/assets/erro.mp3");
          audio.play();
          showToast("Vous ne pouvez pas modifier ce bon", "error");
        }
      } catch (error) {
        showToast("Une erreur est survenue", "error");
      }
    }

    // Selection handlers
    function onSelectAll(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function selectionChanged(params: any) {
      SelectedRows.value = params.selectedRows;
    }
    function onSelectAllColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }
    function selectionChangedColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }

    // Fetch data for the note and parcels
    async function getData() {
      isLoader.value = true;
      try {
        const receptionRes = await api.get("/api/auth/GetNoteRecp", {
          params: { ref: note_BR.value.note_ref },
        });
        reception.value = receptionRes.data;

        const waitingRes = await api.get("/api/auth/ColisWaitingInNote", {
          params: { ref: note_BR.value.note_ref },
        });
        rows1.value = waitingRes.data;

        const pickedRes = await api.get("/api/auth/ColisPickedInNote", {
          params: { ref: note_BR.value.note_ref },
        });
        rows2.value = pickedRes.data;
      } catch (error) {
        // Handle error if needed
      }
      isLoader.value = false;
    }

    // Status variant resolver
    function resolveUserStatusVariant(status: string) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      return "primary";
    }

    const colisId = ref(null);
    const isOpenModal = ref(false);
    const coliDetails = ref<any>({});

    async function showDetailSuivi(row) {
      isOpenModal.value = false;
      colisId.value = null;

      colisId.value = row.id;
      const modalEl = document.getElementById("modal_detail_suivi");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpenModal.value = true;
        modal.show();
      }
      // TODO: Open history modal
    }

    async function showDetails(row) {
      isOpenModal.value = false;
      coliDetails.value = null;
      isOpenModal.value = false;
      coliDetails.value = row;

      const modalEl = document.getElementById("modal_detail_colis");
      if (modalEl) {
        const modal = new Modal(modalEl);
        isOpenModal.value = true;
        modal.show();
      }
      // TODO: Open info modal
    }

    const rowUpdate = ref(null);
    const isOpenEdit = ref(false);
    // Show update modal
    async function showUpdate(row) {
      rowUpdate.value = null;
      isOpenEdit.value = false;
      rowUpdate.value = row;
      nextTick(() => {
        const modalEl = document.getElementById("modal_update");
        console.log(modalEl);
        if (modalEl) {
          isOpenEdit.value = true; // triggers watcher in child

          const modal = new Modal(modalEl);
          modal.show();
        }
      });
    }

    function hideModal(idModal) {
      const modalEl = document.getElementById(idModal);
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      if (modal) {
        modal.hide();
      }
    }
    const statuts = localStorage.getItem("statutsList")
      ? JSON.parse(localStorage.getItem("statutsList") || "")
      : [];

    // Edit parcel
    async function EditColi() {
      const data = new FormData();
      data.append("code", form.code);
      data.append("city_name", city.value.name);
      data.append("city_id", String(city.value.id));
      data.append("price", form.price);
      data.append("phone", form.phone);
      data.append("address", form.address);
      data.append("note", form.note);
      data.append("delivered_fees", form.delivered_fees);
      data.append("returned_fees", form.returned_fees);
      data.append("refused_fees", form.refused_fees);
      data.append("receiver", form.receiver);

      try {
        const res = await api.post(`/api/auth/coli_edit/${form.id}`, data);
        if (res.data.message === "success") {
          showToast("Les données sont bien sauvegardés", "success");
          getData();
        }
      } catch (error) {
        showToast("Une erreur est survenue", "error");
      }
    }

    onMounted(() => {
      console.log("open", props);
      if (props.isOpen) {
        getData();
      }
    });

    watch(
      () => props.noteRow,
      (newVal) => {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("note_BR updated:", newVal);
          getData();
        }
      },
      { immediate: true }
    );

    return {
      isLoader,
      columns,
      fields,
      SelectedRows,
      SelectedNewRows,
      codeColis,
      refreception,
      rows1,
      rows2,
      reception,
      ColiDetails,
      DetailsColis,
      city,
      CitiesList,
      form,
      searchTerm,
      searchTerm1,
      globalStore,
      getDate,
      resolveUserStatusVariant,
      SearchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      showDetailSuivi,
      showDetails,
      showUpdate,
      user,
      auth,

      rowUpdate,
      isOpenEdit,
      hideModal,
      statuts,
      coliDetails,
      colisId,
      isOpenModal,
      EditColi,
      getData,
    };
  },
});
</script>

